<template>
  <div>
    <v-app>
      <v-row
        v-if="hasInitialData"
        no-gutters
      >
        <transition>
          <keep-alive>
            <router-view />
          </keep-alive>
        </transition>
      </v-row>

      <StLoader
        :loading="!hasInitialData"
      />
    </v-app>
  </div>
</template>

<script>
import StLoader from '@stilingue/st-loader';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    StLoader
  },
  computed: {
    ...mapState('misc', [
      'hasInitialData'
    ])
  }
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800');
  @import '~@stilingue/st-styles/main.scss';
  @import '~vuejs-noty/dist/vuejs-noty.css';
  @import './plugins/v-tooltip/v-tooltip.scss';

  * {
    font-family: 'Open Sans', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    overflow-y: auto !important;
  }

  $st-color-dark: #23242d;
  $st-color-carbon: #31323b;
  $st-color-night: #3b3b45;
  $st-color-gray: #5b5b5b;
  $st-color-steel: #7b7b81;

  /*
  .theme--light {
    &.v-application {
      background: var(--gray-500);
    }
  }

  .theme--dark {
    &.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: $st-color-carbon;
    }

    &.v-data-table,
    &.v-sheet,
    &.v-list,
    &.v-tabs-items,
    &.v-navigation-drawer,
    &.v-text-field--solo > .v-input__control > .v-input__slot,
    &.v-card {
      background-color: $st-color-carbon !important;
    }

    &.v-pagination .v-pagination__navigation,
    &.v-pagination .v-pagination__item,
    &.v-application {
      background: $st-color-night !important;
    }

    &.v-app-bar.v-toolbar.v-sheet,
    &.v-toolbar.v-sheet {
      background-color: $st-color-dark !important;
    }
  }
  */

  .st-vue-loader {
    z-index: 4 !important;
  }

  svg {
    overflow: visible !important;
  }

  .overflow-hidden {
    overflow: hidden !important;
  }

  .disabled__container {
    > * {
      opacity: 0.6;
      cursor: default;
      pointer-events: none;
    }
  }

  .grabbing * {
    cursor: grabbing !important;
  }

  /* Override v-calendar background in dark theme */
  .vc-bg-gray-900 {
    background: #1e1e1e !important;
  }

  .reload-on-error {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
</style>
